<template>
  <b-row class="d-flex align-items-center">
    <b-col>
      <b-input-group>
        <b-form-input
          v-model="searchKeyword.keyword"
          placeholder="Firma Adı, Telefon, Vergi No..."
          @keydown.enter="searchAction"
        />
        <b-input-group-append>
          <b-button
            variant="primary"
            @click="searchAction"
          >
            <FeatherIcon icon="SearchIcon" />
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-col>
    <b-col md="auto">
      <b-form-checkbox
        name="check-button"
        switch
        inline
        :checked="detailSearch"
        @change="detailToggle"
      >
        Detaylı Arama
      </b-form-checkbox>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BFormInput, BFormCheckbox, BInputGroup, BInputGroupAppend, BButton,
} from 'bootstrap-vue'

export default {
  name: 'Search',
  components: {
    BRow,
    BCol,
    BFormInput,
    BFormCheckbox,
    BInputGroup,
    BInputGroupAppend,
    BButton,
  },
  props: {
    searchAction: {
      type: Function,
      required: true,
    },
  },
  computed: {
    detailSearch() {
      return this.$store.getters['suppliers/detailSearch']
    },
    searchKeyword() {
      return this.$store.getters['suppliers/search']
    },
  },
  methods: {
    detailToggle() {
      this.$store.commit('suppliers/SET_DETAIL_SEARCH', !this.detailSearch)
    },
  },
}
</script>

<style scoped>

</style>
